import React from 'react'
import {useChatIdWithKind} from '@containers/hooks'
import {ChatHeader} from './chat-header'

export const LocationDependentChatHeader = () => {
  const resFromUrl = useChatIdWithKind()

  return <ChatHeader activeChat={resFromUrl.kind} chatId={resFromUrl.chatId} />
}
